module.exports = require("@swa-ui/application/src/Page/Page.module.scss");